import React from 'react';
import loadable from '@loadable/component'

import withPage, { fetchSlugInfo } from '../page';

const MDP = loadable(() => import('./components'));

const loadData = async (urlParams, store, querySelector) => {
    const { dir, slug, slugTwo, filters } = urlParams;
    const fullSlug = dir && slug ? `/${dir}/${slug}${slugTwo ? `/${slugTwo}` : ''}${filters ? '/' + filters : ''}` : '/';
    await store.dispatch(fetchSlugInfo(fullSlug, { useGraphQL: true }));

    const { slugInfo, redirects, basename } = store.getState();

    const needRedirect = !slugInfo || slugInfo.error || (redirects && redirects.count !== 0);

    const { destination = `${basename}/slp/weekly-deals`, status = 301 } = redirects;
    if (needRedirect) return Promise.resolve({ status, destination });

    return Promise.resolve(slugInfo);
};

export default {
    component: withPage(MDP, { wrapperClassName: 'mdp-root', showWordCloud: true, useV2: true, useGraphQL: true }),
    loadData: loadData
};
